<template>
  <div
    class="d-flex flex-column gr-8 pa-8"
    data-qa="appointment_sidebar"
  >
    <div
      class="text-h6 text--text"
      data-qa="appointment_sidebar_title"
    >
      {{ title }}
    </div>

    <div class="d-flex flex-column gr-6">
      <div
        v-if="calendarDataStore.editableCalendarTitle"
        class="d-flex flex gc-6"
      >
        <div
          class="text-body-1 text-secondary--text"
          :style="{ flex: '0 0 88px' }"
        >
          {{ t('Время', options) }}
        </div>
        <div
          class="text-body-1 text--text"
          data-qa="appointment_sidebar_date"
        >
          {{ calendarDataStore.editableCalendarTitle }}
        </div>
      </div>

      <div class="d-flex gc-6">
        <div
          class="text-body-1 text-secondary--text"
          :style="{ flex: '0 0 88px' }"
        >
          {{ t('Адрес', options) }}
        </div>
        <div
          class="text-body-1 text--text"
          data-qa="appointment_sidebar_address"
        >
          {{ lpuDataStore.lpuData.address }}
        </div>
      </div>

      <div
        v-if="appointmentDataStore.appointmentRegistrationTypes.isDirect && (!appointmentDataStore.isAnyTelemed || calendarDataStore.isCalendarDateSelected)"
        class="d-flex flex-column gr-1"
      >
        <template v-if="appointmentDataStore.isAnyTelemed">
          <template v-if="calendarDataStore.isCalendarDateSelected">
            <div
              class="text-h5 text--text"
              data-qa="appointment_sidebar_telemed_price"
            >
              {{ doctorDataStore.workplacePriceText }}
            </div>

            <div class="text-body-1 text-secondary--text">
              {{ t(priceSubtitle, options) }}
            </div>
          </template>
        </template>
        <template v-else>
          <div
            v-if="doctorDataStore.selectedWorkplace.isFreeWithTreatment"
            class="d-flex align-center gc-2"
          >
            <div
              data-qa="appointment_sidebar_free_appointment"
              class="text-h5 text-success--text"
            >
              {{ t('Бесплатно', options) }}
            </div>
            <span class="ui-icon-tag-discount text-success--text" />
            <div
              class="text-body-1 text-secondary--text text-decoration-line-through ml-2"
              data-qa="appointment_sidebar_full_price"
            >
              {{ doctorDataStore.workplacePriceText }}
            </div>
          </div>
          <div
            v-else-if="isClubPriceVisible"
            class="d-flex align-center gc-1"
          >
            <div
              class="text-h5 error--text"
              data-qa="appointment_sidebar_club_price"
            >
              {{ clubPrice }}
            </div>
            <div
              class="text-body-1 text-secondary--text text-decoration-line-through"
              data-qa="appointment_sidebar_full_price"
            >
              {{ doctorDataStore.workplacePriceText }}
            </div>
          </div>
          <div
            v-else
            class="text-h5 text--text"
            data-qa="appointment_sidebar_full_price"
          >
            {{ doctorDataStore.workplacePriceText }}
          </div>

          <div class="text-body-1 text-secondary--text">
            {{ t(priceSubtitle, options) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import { getSpecialityAgesText } from 'www/vue_components/common/AppointmentPage/functions'
import {
  useLpuDataStore,
  useClubDataStore,
  useDoctorDataStore,
  useCalendarDataStore,
  useAppointmentDataStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import formatPrice from 'src/functions/formatPrice'

const { t, language } = I18NextVue
const options = { ns: language }

const appointmentDataStore = useAppointmentDataStore()
const doctorDataStore = useDoctorDataStore()
const lpuDataStore = useLpuDataStore()
const clubDataStore = useClubDataStore()
const calendarDataStore = useCalendarDataStore()

const title = computed(() => {
  const { speciality, age } = doctorDataStore.selectedWorkplace

  if (!speciality?.name || !age) {
    return ''
  }

  return `${speciality.name}${getSpecialityAgesText(age)}`
})
const isClubPriceVisible = computed(() => (
  appointmentDataStore.isClubPossibleOnPage
  && doctorDataStore.selectedWorkplace.isInClub
  && clubDataStore.isClubPaymentTypeSelected
))
const currencySymbol = window.CURRENCY_DATA.symbol

const clubPrice = computed(() => formatPrice({
  price: doctorDataStore.selectedWorkplace.priceList?.priceClub,
  currencySymbol,
}))
const priceSubtitle = computed(() => (
  (
    appointmentDataStore.appointmentPlaceTypes.isTelemed
    || appointmentDataStore.appointmentPlaceTypes.isTelemedMedtochka
  )
    ? 'Стоимость консультации'
    : 'Стоимость приёма'
))
</script>
